import styled from 'styled-components'
import { colors } from 'Styled/variables'

export const GotItBtnContainer = styled.div`
  margin: 0 auto 40px;
`
export const WrapperForCloseBtn = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
`

export const PriceHintModalHeader = styled.div`
  padding: 16px;
  text-align: right;
`

export const PriceHintModalHeaderCross = styled.div`
  color: ${colors.greyTextWhiteBg};
`

export const PriceHintModalHeaderBtn = styled.button`
  background: none;
`
